import { Pipe, PipeTransform } from "@angular/core";
import { SubscriptionStatus } from "../_types/subscription-status.type";

@Pipe({
    standalone: true,
    name: "subscriptionStatus",
})
export class SubscriptionStatusPipe implements PipeTransform {
    transform(value: number): string {
        return SubscriptionStatus[value];
    }
}
